<div class="pending-edit-dialog">
  <div class="pending-edit-header">
    <div>
      <h2>Editar envío pausado</h2>
      <p>Pedido {{ orderNumber }} · Ticket {{ tkt }}</p>
    </div>
    <button type="button" class="pending-edit-close" aria-label="Cerrar modal" (click)="cancel()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>

  <form *ngIf="signedPayload" #signatureForm="ngForm" (ngSubmit)="save()">
    <div *ngIf="isDigitalSignature()" class="pending-edit-grid">
      <label>
        <span>Nombre</span>
        <input class="form-control" name="name" [(ngModel)]="signedPayload.name" required />
      </label>
      <label>
        <span>RUT</span>
        <div class="pending-edit-rut">
          <input class="form-control" name="rutBody" [ngModel]="rutBody"
            (ngModelChange)="onRutBodyChange($event)" inputmode="numeric" maxlength="8"
            (keydown)="onRutKeyDown($event)" required />
          <strong>-</strong>
          <input class="form-control pending-edit-dv" name="rutDv" [ngModel]="rutDv"
            (ngModelChange)="onRutDvChange($event)" maxlength="1"
            (keydown)="onRutKeyDown($event)" required />
        </div>
      </label>
      <label class="pending-edit-full">
        <span>Correo</span>
        <input class="form-control" type="email" name="email" [(ngModel)]="signedPayload.email"
          [pattern]="emailPattern" [ngModelOptions]="{ updateOn: 'blur' }" #emailModel="ngModel" />
        <small class="text-danger" *ngIf="emailModel.invalid && emailModel.dirty && emailModel.value">
          Por favor ingresa un correo valido.
        </small>
      </label>
    </div>

    <div *ngIf="isDigitalSignature()" class="pending-edit-signature">
      <span>Firma digital</span>
      <app-signature-pad
        [value]="signedPayload.signature"
        [allowAttach]="true"
        [canvasWidth]="600"
        [canvasHeight]="300"
        [topReserveRatio]="0.25"
        (valueChange)="onSignatureChange($event)">
      </app-signature-pad>
    </div>

    <div *ngIf="!isDigitalSignature()" class="pending-edit-paper">
      <app-hormigon-paper-guide-camera [(photoBase64)]="signedPayload.signature"></app-hormigon-paper-guide-camera>
    </div>

    <div class="pending-edit-actions">
      <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
      <button type="submit" class="btn btn-primary" [disabled]="saving">
        {{ saving ? 'Guardando...' : 'Guardar cambios' }}
      </button>
    </div>
  </form>

  <form *ngIf="extraValuesPayload" #extraValuesForm="ngForm" (ngSubmit)="save()">
    <div class="pending-edit-checks">
      <label><input type="checkbox" name="waterAddition" [(ngModel)]="extraValuesPayload.waterAddition" /> Adición de agua</label>
      <label><input type="checkbox" name="anotherAddition" [(ngModel)]="extraValuesPayload.anotherAddition" /> Otro adicional</label>
    </div>
    
    <div class="pending-edit-grid">
      <label>
        <span>Retorno</span>
        <input class="form-control" type="number" min="0" name="m3Returned" [(ngModel)]="extraValuesPayload.m3Returned" />
      </label>
      <label>
        <span>Motivo del retorno</span>
        <select class="form-control" name="reasonToReturn" [(ngModel)]="extraValuesPayload.reasonToReturn">
          <option value="">Seleccionar</option>
          <option *ngFor="let reason of returnReasons" [value]="reason.value">{{ reason.label }}</option>
        </select>
      </label>
      <label class="pending-edit-full">
        <span>Sector (opcional)</span>
        <input class="form-control" type="text" name="m3ReturnedPallet" [(ngModel)]="extraValuesPayload.m3ReturnedPallet" />
      </label>
      <label class="pending-edit-full">
        <span>Observaciones guía</span>
        <textarea class="form-control" rows="5" name="guidingRemarks" [(ngModel)]="extraValuesPayload.guidingRemarks" maxlength="255"></textarea>
      </label>
    </div>

    <div class="pending-edit-actions">
      <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
      <button type="submit" class="btn btn-primary" [disabled]="saving">
        {{ saving ? 'Guardando...' : 'Guardar cambios' }}
      </button>
    </div>
  </form>
</div>
